/**
 * @file CatalogCategoryPicker.tsx
 * @description «Показать: [Весь каталог ▾]» над канвой каталога (phase19.16
 * Р2а; uiux-design-r2a §2): какую страницу каталога показать — весь каталог
 * или категорию, опубликованную на сайте (вид списка и места над/под
 * списком одни на все, а шапка категории и подкатегории видны только на
 * категории). Список категорий — у сотрудника с правом каталога; без него —
 * только «Весь каталог».
 */

import { useEffect, useMemo, useState } from "react";

import { SelectField } from "../../ui/SelectField";
import { useHasPermission } from "../../../auth/hooks";
import { catalogCategories, type CatalogCategory } from "../../../lib/api-catalog";
import { publishedCategoryOptions } from "../../../lib/catalog-category-tree";

const ALL = "";

interface Props {
  /** Адрес категории; `null` — весь каталог. */
  value: string | null;
  onChange: (slug: string | null) => void;
}

export function CatalogCategoryPicker({ value, onChange }: Props) {
  const canCatalog = useHasPermission("SHOP_MANAGE_CATALOG");
  const [categories, setCategories] = useState<CatalogCategory[] | null>(null);
  useEffect(() => {
    if (!canCatalog) return;
    let alive = true;
    catalogCategories
      .list()
      .then((list) => alive && setCategories(list))
      .catch(() => alive && setCategories([]));
    return () => {
      alive = false;
    };
  }, [canCatalog]);
  const options = useMemo(() => [{ value: ALL, label: "Весь каталог" }, ...publishedCategoryOptions(categories ?? [])], [categories]);
  return (
    <label className="flex min-w-0 items-center gap-2">
      <span className="type-caption shrink-0 text-on-surface-variant">Показать:</span>
      <span className="min-w-0 flex-1 sm:w-64 sm:flex-none">
        <SelectField ariaLabel="Что показать на канве каталога" placeholder="Весь каталог" value={value ?? ALL} options={options} onChange={(v) => onChange(v === ALL ? null : v)} />
      </span>
    </label>
  );
}
